<template>
  <div class="app-wrapper">
    <router-view v-slot="{ Component }">
      <transition name="page-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <transition name="loader-fade">
      <div v-if="isLoading" class="loading-screen">
        <div class="cool-loader"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    // 加长一点时间让加载动画更明显
    setTimeout(() => {
      this.isLoading = false;
    }, 1500);
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  width: 100%;
  height: 100%;
  overflow: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

html::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

body::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

#app {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

#app::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* 大屏幕时固定高度 */
@media (min-width: 415px) {
  body {
    overflow: hidden;
    height: 100vh;
  }
  
  #app {
    height: 100vh;
    overflow: hidden;
  }
}

/* 页面切换动画 */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1), transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-fade-enter-from {
  opacity: 0;
  transform: translateY(15px) scale(0.98);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-15px) scale(0.98);
}

.loader-fade-leave-active {
  transition: opacity 0.2s ease;
}

.loader-fade-leave-to {
  opacity: 0;
}

/* 初始加载动画 */
.loading-screen {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}

/* 炫酷的加载动画 */
.cool-loader {
  position: relative;
  width: 64px;
  height: 64px;
}

.cool-loader::before, .cool-loader::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
}

.cool-loader::before {
  border-top-color: #ff0f7b;
  border-right-color: #ff0f7b;
  animation: spin 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
  box-shadow: 0 0 20px rgba(255, 15, 123, 0.5);
}

.cool-loader::after {
  border-bottom-color: #ff6b42;
  border-left-color: #ff6b42;
  animation: spinReverse 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
  box-shadow: 0 0 20px rgba(255, 107, 66, 0.5);
}

@keyframes spin {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.2); }
  100% { transform: rotate(360deg) scale(1); }
}

@keyframes spinReverse {
  0% { transform: rotate(360deg) scale(1); }
  50% { transform: rotate(180deg) scale(0.8); }
  100% { transform: rotate(0deg) scale(1); }
}
</style>
